import { routes } from './areasinteresse.routes';
import ForListAreasInteresseController from "./directory/directory.controller";
export default angular.module('app.formacao.areasinteresse', [])
    .config(routes)
    .controller('ForListAreasInteresseController', ForListAreasInteresseController)
    .name;
